const STORAGE_KEY = 'docsdone_signup_intent'

export type SignupComposition = {
  sender_seats: number
  completions_per_month: number
  active_envelopes: number
  retention_days: number
  collaboration: boolean
  legal_hold: boolean
}

export type StoredSignupIntent = {
  utm_source?: string
  plan?: string
  composition: SignupComposition
  monthly_cents?: number
}

const PARAMS = [
  'utm_source',
  'plan',
  'seats',
  'completions',
  'active',
  'retention',
  'collaboration',
  'legal_hold',
] as const

/** Capture marketing calculator query params before sign-in replaces the URL. */
export function captureSignupIntentFromLocation(search: string): StoredSignupIntent | null {
  const q = new URLSearchParams(search)
  if (!q.get('seats') && !q.get('completions') && q.get('plan') !== 'custom') {
    return null
  }
  const composition: SignupComposition = {
    sender_seats: int(q.get('seats'), 5),
    completions_per_month: int(q.get('completions'), 500),
    active_envelopes: int(q.get('active'), 200),
    retention_days: int(q.get('retention'), 1095),
    collaboration: q.get('collaboration') === '1',
    legal_hold: q.get('legal_hold') === '1',
  }
  const intent: StoredSignupIntent = {
    utm_source: q.get('utm_source') ?? undefined,
    plan: q.get('plan') ?? undefined,
    composition,
  }
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(intent))
  return intent
}

export function readStoredSignupIntent(): StoredSignupIntent | null {
  const raw = sessionStorage.getItem(STORAGE_KEY)
  if (!raw) return null
  try {
    return JSON.parse(raw) as StoredSignupIntent
  } catch {
    return null
  }
}

export function clearStoredSignupIntent(): void {
  sessionStorage.removeItem(STORAGE_KEY)
}

function int(raw: string | null, fallback: number): number {
  if (!raw) return fallback
  const n = parseInt(raw, 10)
  return Number.isFinite(n) ? n : fallback
}

export function signupIntentQueryPresent(search: string): boolean {
  const q = new URLSearchParams(search)
  return PARAMS.some((k) => q.has(k))
}
